module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門5_10.b4fe742e.png";